import React from 'react'
import SocialNetworksForm, {
    SocialNetworksFormState,
} from 'components/forms/establishment/socialNetworksForm'
import SubmitButton from 'components/common/submitButton'
import clsx from 'clsx'
import { useStyles } from './styles.css'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    useMediaQuery,
    useTheme,
} from '@material-ui/core'
import { Trans } from 'react-i18next'
import CloseButton from 'components/dialogs/closeButton'

interface Props {
    open: boolean
    onClose: () => void
    onSubmit: (values: SocialNetworksFormState) => void
    inProgress: boolean
    initialValues: SocialNetworksFormState
}

const EstablishmentSocialNetworksDialogView: React.FC<Props> = ({ open, onClose, ...formData }) => {
    const classes = useStyles()

    const theme = useTheme()
    const fullScreen = useMediaQuery(theme.breakpoints.down('xs'))

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={fullScreen}
            scroll="paper"
            classes={{
                paper: classes.paper,
            }}
            maxWidth="md"
        >
            <SocialNetworksForm formClassName={classes.form} {...formData}>
                {(content, actions) => (
                    <>
                        <DialogTitle>
                            <Trans i18nKey="views.establishment.socialNetworks.title" />
                        </DialogTitle>
                        <DialogContent dividers>
                            <CloseButton onClose={onClose} />
                            {content}
                        </DialogContent>
                        <DialogActions className={classes.actions}>
                            <Button variant="contained" onClick={onClose}>
                                <Trans i18nKey="actions.cancel" />
                            </Button>
                            {actions.map((action, index) => (
                                <SubmitButton
                                    key={index}
                                    variant="contained"
                                    color="primary"
                                    {...action}
                                    className={clsx(action.className)}
                                >
                                    <Trans i18nKey="actions.validate" />
                                </SubmitButton>
                            ))}
                        </DialogActions>
                    </>
                )}
            </SocialNetworksForm>
        </Dialog>
    )
}

export default EstablishmentSocialNetworksDialogView
